import { observer } from 'mobx-react';
import { wizardModeOptions } from 'Models/Enums';
import React from 'react';
import { useIntl } from 'react-intl';
import { useOptionalMessage } from 'Hooks/useOptionalMessage';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';

import { AddOnsCollection } from './AddOnCollection';
import ParkingAddOnSection from './ParkingAddOnSection';
import { SelectedTrips } from '../../BookingWizardWrap';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { WizardStepHeader } from '../Shared/WizardStepHeader';

interface AddOnsContextProps {
	selectedTrips: SelectedTrips;
}
export const AddOnsContext = React.createContext<AddOnsContextProps>({ selectedTrips: {} });

interface AddOnsTabProps {
	selectedTrips: SelectedTrips;
	bookingType: TabSelected;
}

function AddOnsTab(props: AddOnsTabProps) {
	const intl = useIntl();
	const fmtOptional = useOptionalMessage();
	const { wizardData } = useBookingWizardDataStore();

	const subtitle = fmtOptional({
		id: 'add-on-tab__subtitle',
		defaultMessage: 'Choose any extras to enhance your trip.',
	});

	return (
		<div className="booking-wizard-tab">
			<WizardStepHeader
				iconName="library_add"
				title={intl.formatMessage({ id: 'add-on-tab__title', defaultMessage: 'Pick your add-ons' })}
				subtitle={subtitle || undefined}
				showCloseLink={wizardData.wizardMode === wizardModeOptions.ALTERATION}
				bookingToEditId={wizardData?.bookingToEdit ?? ''}
			/>
			<AddOnsContext.Provider value={props}>
				<AddOnsCollection bookingType={wizardData.tabSelected} userId={wizardData.userId} />
			</AddOnsContext.Provider>
			{/* TODO: Re-enable parking add-on section when booking wizard integration is complete
			{appConfigStore.parkingEnabled && (
				<ParkingAddOnSection selectedTrips={selectedTrips} />
			)}
			*/}
			{/* The original "Additional information" note now renders in the
			    DynamicFieldsSection ("Additional information" section) on the Details tab. */}
		</div>
	);
}

export default observer(AddOnsTab);
